module.exports = __webpack_public_path__ + "static/media/15_tn.59b14fa4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/15_tn.jpg
// module id = 651
// module chunks = 0